// extracted by mini-css-extract-plugin
export default {"slide":"styles_slide__Mmwbb","left":"styles_left__Y-iz2","right":"styles_right__xsTlZ","controls":"styles_controls__48KPV"};